<div class="p-8 bg-gray-50 rounded-lg shadow-xl">
  <h2 class="text-2xl font-bold mb-6 text-black">Edit TTM Map</h2>

  <!-- Attribute Dropdown -->
  <div class="mb-4">
    <label class="block text-lg font-semibold mb-4 text-gray-600">Global Record Filter</label>
    <select [(ngModel)]="selectedGlobalRecordFilter"
      class="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none focus:border-blue-500">
      <option value="" disabled selected hidden>Select Filter</option>
      <option *ngFor="let key of objectKeys(formData.sourceMetaData)" [value]="key">{{ key }}</option>
    </select>
  </div>

  <!-- Source Metadata Section -->
  <div class="mb-8">
    <h3 class="text-lg font-semibold mb-4 text-gray-600">Source Meta Data</h3>
    <div class="overflow-x-auto">
      <table class="min-w-full text-sm bg-white border border-gray-200 rounded-lg">
        <thead class="bg-gray-100 text-gray-600">
          <tr>
            <th class="text-left px-4 py-3 font-medium">Attribute</th>
            <th class="text-left px-4 py-3 font-medium">Data Type</th>
            <th class="text-left px-4 py-3 font-medium">Length</th>
            <th class="text-left px-4 py-3 font-medium">Scale</th>
            <th class="text-left px-4 py-3 font-medium">Precision</th>
            <th class="text-left px-4 py-3 font-medium">Source Date Format</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let key of objectKeys(formData.sourceMetaData)" class="border-t border-gray-200 hover:bg-gray-50">
            <td class="px-4 py-3 text-gray-800">{{ key }}</td>
            <td class="px-4 py-3">
              <input [(ngModel)]="formData.sourceMetaData[key].dataType"
                class="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none ">
            </td>
            <td class="px-4 py-3">
              <input [(ngModel)]="formData.sourceMetaData[key].length"
                class="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none ">
            </td>
            <td class="px-4 py-3">
              <input [(ngModel)]="formData.sourceMetaData[key].scale"
                class="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none ">
            </td>
            <td class="px-4 py-3">
              <input [(ngModel)]="formData.sourceMetaData[key].precision"
                class="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none ">
            </td>
            <td class="px-4 py-3">
              <input [(ngModel)]="formData.sourceMetaData[key].sourceDateFormat"
                class="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none ">
            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="mb-8">
    <h3 class="text-lg font-semibold mb-4 text-gray-600">Filter</h3>

    <!-- Attribute Dropdown -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-600 mb-1">Attributes</label>
      <select [(ngModel)]="selectedSourceAttribute" (ngModelChange)="onSourceAttributeChange()"
        class="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none focus:border-blue-500">
        <option value="" disabled selected hidden>Select Attribute</option>
        <option *ngFor="let key of objectKeys(formData.sourceMetaData)" [value]="key">{{ key }}</option>
      </select>

    </div>




    <!-- Filters Section -->
    <div *ngIf="selectedSourceAttribute">

      <!-- Not Null Checkbox -->
      <div class="mb-4">
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="notNullState[selectedSourceAttribute]"
            (ngModelChange)="onNotNullChange(selectedSourceAttribute)"
            class="form-checkbox h-4 w-4 text-blue-600 rounded mr-2 cursor-pointer" />
          <label class="text-sm font-medium text-gray-700">Not Null</label>
        </div>
      </div>

      <!-- Filter Rules -->
      <div *ngFor="let rule of getAttributeFilters(selectedSourceAttribute); let i = index"
        class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm space-y-4 mb-4">
        <!-- Filter Rule Header -->
        <div class="flex items-center">
          <label class="text-sm font-medium text-gray-700">Filter Rule {{ i + 1 }}</label>
          <button type="button" class="text-xl ml-auto text-red-500 hover:text-red-700"
            (click)="removeFilterRule(selectedSourceAttribute, i)">&times;</button>
        </div>

        <!-- Filter Rule Details -->
        <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
          <!-- Filter Type -->
          <div>
            <label class="block text-sm text-gray-600 mb-1">Filter</label>
            <select [(ngModel)]="rule.filter" (ngModelChange)="onFilterChange(rule)"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500">
              <option value="" disabled selected hidden>Select Filter</option>
              <option *ngFor="let filter of filterOptions" [value]="filter"
                [disabled]="isFilterDisabled(selectedSourceAttribute, rule, filter)">
                {{ filter }}
              </option>
            </select>
          </div>

          <!-- Data Type -->
          <div *ngIf="filterDataTypes[rule.filter]">
            <label class="block text-sm text-gray-600 mb-1">Type</label>
            <select [(ngModel)]="rule.type"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500">
              <option value="" disabled selected hidden>Select Type</option>
              <option *ngFor="let type of filterDataTypes[rule.filter]" [value]="type">{{ type }}</option>
            </select>
          </div>

          <!-- Operator -->
          <div>
            <label class="block text-sm text-gray-600 mb-1">Operator</label>
            <select [(ngModel)]="rule.operator"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500">
              <option value="" disabled selected hidden>Select Operator</option>
              <option *ngFor="let op of operatorOptions" [value]="op">{{ op }}</option>
            </select>
          </div>

          <!-- Values -->
          <div *ngIf="rule.type">
            <label class="block text-sm text-gray-600 mb-1">Value</label>
            <div
              class="flex flex-wrap w-full items-center border border-gray-300 rounded-lg px-3 py-2 focus-within:border-blue-500">
              <span *ngFor="let val of rule.values; let j = index"
                class="flex items-center bg-gray-200 text-gray-700 rounded-full px-2 py-1 mr-2 mb-2">
                {{ val }}
                <button type="button" (click)="removeValueFromRule(rule, j)"
                  class="ml-2 text-gray-500 hover:text-gray-700">&times;</button>
              </span>
              <input type="text" [(ngModel)]="currentValue" (keydown.enter)="addValueToRule($event, rule)"
                placeholder="Type value and press Enter" class="flex-grow min-w-[200px] px-2 py-1 focus:outline-none" />
            </div>
          </div>
        </div>
      </div>

      <!-- Save Filter Button -->
      <div class="flex justify-end mb-4">
        <button type="button" class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
          (click)="saveCurrentFilter()">
          Save Filter
        </button>
      </div>

      <!-- Add Filter Button -->
      <button type="button" (click)="addFilterRule(selectedSourceAttribute)"
        class="bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
        + Add Filter
      </button>

    </div>


  </div>

  <!-- Target Meta Data -->
  <div class="mb-8">
    <h3 class="text-lg font-semibold mb-4 text-gray-600">Target Meta Data</h3>
    <div class="border border-gray-200 p-4 mb-4 rounded-lg bg-white shadow-sm">
      <div class="grid grid-cols-2 gap-4">
        <mat-form-field appearance="fill" class="w-full custom-material-select mt-2 h-18">
          <mat-label class="text-sm text-gray-600">Attributes</mat-label>
          <mat-select [(ngModel)]="formData.targetMetaData.attributes" multiple class="text-sm">
            <mat-option *ngFor="let key of objectKeys(formData.sourceMetaData)" [value]="key">
              {{ key }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Map To</label>
          <input type="text" [(ngModel)]="formData.targetMetaData.mapTo" placeholder="Enter comma-separated values"
            class="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none focus:border-blue-500" />
        </div>
      </div>
    </div>
  </div>

  <!-- Buttons -->
  <div class="flex justify-end gap-3">
    <button mat-raised-button class="text-red-600 border border-red-600 hover:bg-red-50 px-4 py-2 rounded-lg"
      (click)="cancel()">Cancel</button>
    <button mat-raised-button class="bg-green-600 text-white hover:bg-green-700 px-4 py-2 rounded-lg"
      (click)="save()">Save</button>
  </div>
</div>